import EndDateRecurrence from 'owa-service/lib/contract/EndDateRecurrence';
import { CalendarEvent } from 'mini-calendar-event-types';
import { calendarEvent } from 'mini-calendar-event-converter';
import { getFilteredUserConfiguration } from 'mini-settings/lib/selectors/getFilteredUserConfiguration';
import { isBefore, now, OwaDate, owaDate } from 'owa-datetime';
import { isRecurrenceMaster } from 'mini-calendar-event-services/lib/utils/isRecurrenceMaster';
import { isRecurringItem } from 'mini-calendar-event-services/lib/utils/isRecurringItem';
import { MeetingMessageType } from 'mini-calendar-event-services/lib/schema/MeetingMessageType';

/**
 * Given a meeting item it determines if it occurs in the past, except for a few cases of recurrence where the
 * event started in the past as a series but did not end yet
 * @param meetingItem
 */
export const isMeetingItemForPastEvent = (meetingItem: MeetingMessageType): boolean => {
    const meeting: CalendarEvent = calendarEvent(meetingItem);

    return isCalendarEventForPastTimeOrRecurrence(meeting);
};

export const isCalendarEventForPastTimeOrRecurrence = (meeting: CalendarEvent): boolean => {
    // Return it is a meeting request that is in the past, either as a single event, instance or an exception
    if (!isRecurringItem(meeting) || !isRecurrenceMaster(meeting)) {
        return meeting.IsPastEvent;
    }

    // If there is no end for the recurrence, then we say that it is not a past event
    const recurrenceEndDateFromServer = (meeting?.Recurrence?.RecurrenceRange as EndDateRecurrence)
        ?.EndDate;

    if (!recurrenceEndDateFromServer) {
        return false;
    }

    const timeZoneId = getFilteredUserConfiguration()?.UserOptions?.MailboxTimeZoneOffset?.[0]
        ?.TimeZoneId;

    const endDate: OwaDate = owaDate(timeZoneId, recurrenceEndDateFromServer);

    return isBefore(endDate, now());
};
